import dayjs from 'dayjs';

export default class NewGuiaModel {
    constructor(data = {}) {
        this.cabecera = {
            id: parseInt(data.cabecera?.id) || 0,
            usuario: parseInt(data.cabecera?.usuario) || 0,
            matricula_Vehiculo: data.cabecera?.matricula_Vehiculo || '',
            viniedo: data.cabecera?.viniedo || '',
            titular_Viniedo: data.cabecera?.titular_Viniedo || '',
            ubicacion_Viniedo_x:
                parseFloat(data.cabecera?.ubicacion_Viniedo_x) || 0,
            ubicacion_Viniedo_y:
                parseFloat(data.cabecera?.ubicacion_Viniedo_y) || 0,
            departamento_Viniedo: data.cabecera?.departamento_Viniedo || '',
            titular_Destinatario: data.cabecera?.titular_Destinatario || '',
            ubicacion_Destinatario: data.cabecera?.ubicacion_Destinatario || '',
            departamento_Destinatario:
                parseInt(data.cabecera?.departamento_Destinatario) || 0,
            total_Kilos: parseInt(data.cabecera?.total_Kilos) || 0,
            fecha_Envio: data.cabecera?.fecha_Envio
                ? dayjs(data.cabecera?.fecha_Envio).format('YYYY-MM-DD')
                : '',
            firma_Viticultor: data.cabecera?.firma_Viticultor || '',
            firma_Destinatario: data.cabecera?.firma_Destinatario || '',
            doc_id_tipo: parseInt(data.cabecera?.doc_id_tipo) || 0,
            doc_id: data.cabecera?.doc_id || '',
            doc_id_tipo_Destinatario:
                parseInt(data.cabecera?.doc_id_tipo_Destinatario) || 0,
            doc_id_Destinatario: data.cabecera?.doc_id_Destinatario || '',
            total_Kilos_Recibidos:
                parseInt(data.cabecera?.total_Kilos_Recibidos) || 0,
            fecha_Recepcion: data.cabecera?.fecha_Recepcion
                ? dayjs(data.cabecera?.fecha_Recepcion).format('YYYY-MM-DD')
                : '',
            bodega_Id: parseInt(data.cabecera?.bodega_Id) || 0,
            serie: parseInt(data.cabecera?.serie) || 0,
            numero: parseInt(data.cabecera?.numero) || 0,
            djcP_Id: parseInt(data.cabecera?.djcP_Id) || 0,
            estado: parseInt(data.cabecera?.estado) || 0,
            token_Bodega: data.cabecera?.token_Bodega || '',
            token_QR: data.cabecera?.token_QR || '',
            imagen: data.cabecera?.imagen || '',
            guia_Papel: data.cabecera?.guia_Papel || '',
            destino: data.cabecera?.destino
                ? parseInt(data.cabecera.destino)
                : 0,
        };
        this.itemsProductor = data.itemsProductor || [];
        this.itemsBodega = data.itemsBodega || [];
    }
}
